import "./datatable.scss";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import newRequest from "../../context/newRequest";
import debounce from "lodash.debounce";
import useRegions from "../../hooks/useRegions";

const DatatableSolveClosed = ({ columns }) => {
    const { regions } = useRegions();
    const location = useLocation();
    const path = location.pathname.split("/")[1];

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState({
        userId: "",
        ticketId: "",
        statusId: "",
        customer: "",
        month: "",
        year: "",
        regionId: "",
        startDate: "",
        endDate: "",
        order: "DESC",
    });

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const fetchData = async () => {
        try {
            setLoading(true);

            const params = new URLSearchParams({
                userId: filters.userId,
                ticketId: filters.ticketId,
                status_id: filters.statusId,
                site_customer: filters.customer,
                month: filters.month,
                year: filters.year,
                region_id: filters.regionId,
                start_date: filters.startDate,
                end_date: filters.endDate,
                order: filters.order,
            });

            const response = await newRequest.get(
                `/v1/${path}/query?${params.toString()}`
            );

            console.log("API RESPONSE:", response.data);

            setData(response.data?.data ?? []);

        } catch (error) {
            console.error("Failed fetch ticket:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handler = debounce(() => {
            fetchData();
        }, 500);

        handler();

        return () => {
            handler.cancel();
        };
    }, [filters, path]);

    const handleFilterChange = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));

        // kalau filter berubah, balik ke page pertama
        setPage(0);
    };

    const handleReset = () => {
        setFilters({
            userId: "",
            ticketId: "",
            statusId: "",
            customer: "",
            month: "",
            year: "",
            regionId: "",
            startDate: "",
            endDate: "",
            order: "DESC",
        });

        setPage(0);
        setPageSize(10);
    };

    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => (
                <div className="cellAction">
                    <Link
                        to={`/solve/${params.row.ticket_id}`}
                        style={{ textDecoration: "none" }}
                    >
                        <div className="viewButton">
                            View
                        </div>
                    </Link>

                    <Link
                        to={`/solve/update/${params.row.ticket_id}`}
                        style={{ textDecoration: "none" }}
                    >
                        <div className="updateButton">
                            Update Solved
                        </div>
                    </Link>

                    <Link
                        to={`/closed/update/${params.row.ticket_id}`}
                        style={{ textDecoration: "none" }}
                    >
                        <div className="updateButton">
                            Update Close
                        </div>
                    </Link>
                </div>
            ),
        },
    ];

    return (
        <div className="datatable">

            <div className="datatableTitle">
                Ticket {path.toUpperCase()}
            </div>

            <div className="column-search">

                {/* USER + TICKET */}
                <div className="search">
                    <input
                        type="text"
                        placeholder="userId"
                        value={filters.userId}
                        onChange={(e) =>
                            handleFilterChange(
                                "userId",
                                e.target.value
                            )
                        }
                    />

                    <SearchOutlinedIcon />

                    <input
                        type="text"
                        placeholder="TicketId"
                        value={filters.ticketId}
                        onChange={(e) =>
                            handleFilterChange(
                                "ticketId",
                                e.target.value
                            )
                        }
                    />
                </div>

                {/* STATUS + CUSTOMER */}
                <div className="search">
                    <input
                        type="text"
                        placeholder="StatusID"
                        value={filters.statusId}
                        onChange={(e) =>
                            handleFilterChange(
                                "statusId",
                                e.target.value
                            )
                        }
                    />

                    <SearchOutlinedIcon />

                    <input
                        type="text"
                        placeholder="Segment Cust"
                        value={filters.customer}
                        onChange={(e) =>
                            handleFilterChange(
                                "customer",
                                e.target.value
                            )
                        }
                    />
                </div>

                {/* MONTH + YEAR */}
                <div className="search">
                    <input
                        type="text"
                        placeholder="Month"
                        value={filters.month}
                        onChange={(e) =>
                            handleFilterChange(
                                "month",
                                e.target.value
                            )
                        }
                    />

                    <SearchOutlinedIcon />

                    <input
                        type="text"
                        placeholder="Year"
                        value={filters.year}
                        onChange={(e) =>
                            handleFilterChange(
                                "year",
                                e.target.value
                            )
                        }
                    />
                </div>

                {/* DATE */}
                <div className="search">

                    <input
                        type="date"
                        value={filters.startDate}
                        onChange={(e) =>
                            handleFilterChange(
                                "startDate",
                                e.target.value
                            )
                        }
                    />

                    --

                    <input
                        type="date"
                        value={filters.endDate}
                        onChange={(e) =>
                            handleFilterChange(
                                "endDate",
                                e.target.value
                            )
                        }
                    />

                </div>

                {/* ORDER + REGION */}
                <div className="search">

                    <select
                        value={filters.order}
                        onChange={(e) =>
                            handleFilterChange(
                                "order",
                                e.target.value
                            )
                        }
                    >
                        <option value="DESC">
                            DESC
                        </option>

                        <option value="ASC">
                            ASC
                        </option>
                    </select>

                    <select
                        value={filters.regionId}
                        onChange={(e) =>
                            handleFilterChange(
                                "regionId",
                                e.target.value
                            )
                        }
                    >
                        <option value="">
                            Pilih Region Id
                        </option>
                        {regions.map((reg) => (
                            <option key={reg.id || reg.name} value={reg.name}>
                                {reg.name}
                            </option>
                        ))}
                    </select>

                </div>

                {/* RESET */}
                <div className="search">

                    <button
                        onClick={handleReset}
                        className="reset"
                    >
                        Reset
                    </button>

                </div>

            </div>

            <br />
            <br />

            <DataGrid
                className="datagrid"
                columns={columns.concat(actionColumn)}
                components={{
                    Toolbar: GridToolbar
                }}    checkboxSelection

                autoHeight
                rows={data}
                loading={loading}
                getRowId={(row) => row.id}
                pagination
                page={page}
                pageSize={pageSize}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                onPageChange={(newPage) => {
                    setPage(newPage);
                }}
                onPageSizeChange={(newPageSize) => {
                    setPageSize(newPageSize);
                    setPage(0);
                }}
            />

        </div>
    );
};

export default DatatableSolveClosed;